module.exports = __webpack_public_path__ + "img/karagandy4.7a51d0f6.jpg";